import { render, staticRenderFns } from "./HomesList.vue?vue&type=template&id=6bd273cc"
import script from "./HomesList.vue?vue&type=script&lang=js"
export * from "./HomesList.vue?vue&type=script&lang=js"
import style0 from "./HomesList.vue?vue&type=style&index=0&id=6bd273cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports